import AitiCoreClientFoxentry from './clients/foxentry';
import AitiCoreClientGtm from './clients/gtm';

export default class AitiCoreClients {

    private readonly _foxentryClient: AitiCoreClientFoxentry;
    private readonly _gtmClient: AitiCoreClientGtm;

    constructor() {
        this._foxentryClient = new AitiCoreClientFoxentry();
        this._gtmClient = new AitiCoreClientGtm();
    }

    getFoxentryClient() {
        return this._foxentryClient;
    }

    getGtmClient() {
        return this._gtmClient;
    }
}
